<mat-toolbar class="subtitulo">Atendimento e Visitas</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <!-- DATA DO ATENDIMENTO-->
            <div fxLayout="column" fxFlex="18%">
                <mat-toolbar class="titulopartes">Data do atendimento</mat-toolbar>
                <mat-form-field style="margin: 0 20px 20px 20px">
                    <input matInput name="dataAtendimento" [matDatepicker]="dataAtendimento" placeholder="Data:"
                        [(ngModel)]="atendimento.dataAtendimento" required (input)="onMascaraDataInput($event)">
                    <mat-datepicker-toggle matSuffix [for]="dataAtendimento"></mat-datepicker-toggle>
                    <mat-datepicker #dataAtendimento></mat-datepicker>
                </mat-form-field>
            </div>

            <!-- ALUNO -->
            <div fxLayout="column" fxFlex="80%">
                <mat-toolbar class="titulopartes">Beneficiário</mat-toolbar>
                <div ngModelGroup="comboBeneficiario" fxFlex="100" fxLayoutGap="20px" style="padding-top: 15px;">
                    <combo-beneficiario [showDisplayId]="false" 
                                        [obrigatorio]="true" 
                                        [selecionado]="alunoCombo"
                                        (valorChange)="onValorChange($event)">
                    </combo-beneficiario>
                </div>

            </div>
        </div>

        <div *ngIf="atendimento.aluno.id && atendimento.aluno.pessoaFisica">
                <dados-aluno [aluno]=atendimento.aluno></dados-aluno>
            </div>

        <div ngModelGroup="comboContratoProjetoPrograma_{{idRandomico}}">
            <combo-pesquisavel #comboContratoProjetoPrograma
                                nome="descricao" 
                                [itens]="combosContratosProjetosProgramas" 
                                itemDescricao="descricao"
                                itemId="id"
                                [showDisplayId]="false" 
                                [obrigatorio]="false"
                                placeholder="Selecione o item..."
                                [(valor)]="comboContratoProjetoProgramaSelecionado"
                                (valorChange)="onValorComboContratoProjetoProgramaChange($event)">
            </combo-pesquisavel>
        </div>
            
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <!--  DIAGNOSTICO-->
            <div fxLayout="column" fxFlex="45%">
                <mat-toolbar class="titulopartes">Diagnóstico</mat-toolbar>
                <mat-form-field style="margin: 0 20px 20px 20px">
                        <mat-label>Diagnósticos:</mat-label>
                        <mat-select [(ngModel)]="atendimento.diagnostico.id" name="diagnostico" required>
                                <mat-option></mat-option>
                                <mat-option *ngFor="let i of diagnosticos" [value]="i.id">
                                        {{i.descricao}}
                                </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="diagnosticos?.length === 0" align="start">Nenhum diagnóstico
                                cadastrado</mat-hint>
                </mat-form-field>

                <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                        <mat-label>Descrição diagnóstico:</mat-label>
                        <textarea #observacoes matInput name="descDiagnosticos" [(ngModel)]="atendimento.descDiagnostico" cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="1000"></textarea>
                            <mat-hint align="end">{{observacoes.value.length}} / 1000</mat-hint>
                    </mat-form-field>

            </div>

           <!--  SOLUÇÃO-->
           <div fxLayout="column" fxFlex="45%">
                <mat-toolbar class="titulopartes">Solução</mat-toolbar>
                <mat-form-field style="margin: 0 20px 20px 20px">
                    <mat-label>Soluções</mat-label>
                    <mat-select [(ngModel)]="atendimento.solucoes.id" name="solucoes">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let i of solucoes" [value]="i.id">
                                {{i.descricao}}
                            </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="solucoes?.length === 0" align="start">Nenhuma solução cadastrada</mat-hint>
                </mat-form-field>

                <mat-form-field style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
                    <mat-label>Descrição solução:</mat-label>
                    <textarea #descSolucao matInput name="descSolucoes" [(ngModel)]="atendimento.descSolucao" cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="1000"></textarea>
                        <mat-hint align="end">{{descSolucao.value.length}} / 1000</mat-hint>
                </mat-form-field>

            </div>
        </div>

        <mat-tab-group>
            <mat-tab label="METAS">
                <div ngModelGroup="grupoAtendimentoMetas" fxLayout="column" fxFlex="100%" style="margin: 2px 0;">
                    <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px">
                        <div *ngFor="let meta of atendimento.metas; let index = index">
                            <formulario-atendimentos-metas [meta]="meta"
                                                    [index]="index"
                                                    [metas]="atendimento.metas"
                                                    [perfilAcesso]="perfilAcesso"
                                                    [atendimentos]="atendimentos.concat(atendimento)">
                            </formulario-atendimentos-metas>
                        </div>
                        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
                            style="padding-top: 10px; padding-left: 20px;">
                            <div>
                                <button matTooltip="Nova Meta" mat-mini-fab color="primary" (click)="addMeta()"
                                        style="width: 140px;border-radius: 5px;">
                                    <mat-icon>add</mat-icon>
                                    Meta
                                </button>
                            </div>
                        </div>
                    </div>
                </div> 
            </mat-tab>
        </mat-tab-group>


        <!-- BOTOES -->
        <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
            <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()"> Cadastrar
            </button>

            <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar" fxFlex="20%"
                color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                Atualizar
            </button>

            <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                Limpar
            </button>
            <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                Cancelar
            </button>

        </div>
    </form>

</div>